import {useTranslation} from "react-i18next";
import ScorePrice from "../ScorePrice/ScorePrice";
import { v4 as uuidv4 } from 'uuid';
import {useAuth} from "../../services/use-auth";
import classNames from 'classnames';

export default function Survey({item, allCategories, isPinned}) {
    const { t } = useTranslation();
    const auth = useAuth();
    const isAuthenticated = !!auth.user;

    const {id, image, title, prices, sponsors, isPublic, categories, isFinished} = item;
    const isRegistrationRequired = !isAuthenticated && !isPublic;

    const needToRenderSponsors = sponsors.length && isAuthenticated;
    const needToRenderTop = isPinned && isAuthenticated;

    return (
        <a className={classNames('surveyItem', {'not-active': isFinished})} href={"/surveys/" + id}>
            <div className="img-wrap">
                { !!isRegistrationRequired &&
                    <div className="not-public-label">
                        <span className="icon-lock"/>
                        {t('surveys.registrationRequired')}
                    </div>
                }
                { !!needToRenderSponsors &&
                    <div className="sponsors-block">
                        <div className="survey-sponsors">
                            {sponsors.map(sponsor =>
                                <div key={uuidv4()} onClick={sponsor.url ? (() => window.location.href = sponsor.url) : undefined}>
                                    <img alt="" src={"/" + sponsor.image.replace(/^\/+/, '')} />
                                </div>
                            )}
                        </div>
                    </div>
                }
                { !!needToRenderTop && <div className="is-top-label">{t('surveys.top')}</div>}
                <img src={"/" + image.replace(/^\/+/, '')} alt="" className="img-fill" />
                    <div className="title-block">
                        { categories.map(category => <p key={uuidv4()}>{allCategories.find(item => item.id === category).name}</p>) }
                        <h6>{title}</h6>
                    </div>
            </div>
            <div className="score-info">
                <div className="score-inline">
                    { prices.map(price => <ScorePrice key={uuidv4()} {...price} />) }
                </div>
            </div>
        </a>
    );
}
